import mem from "mem";
import getClient from "src/services/contentful/contentful";
import tagParser, { TagParsed } from "./tagParser";

async function getTags(preview?: boolean): Promise<TagParsed[]> {
  const response = await getClient({ preview }).getTags();
  return response.items.map(tagParser);
}

const maxAge = 1000 * 60 * 60; // 1hour
export default mem(getTags, { maxAge });
